import { render, staticRenderFns } from "./EditOptions.vue?vue&type=template&id=8e20c8f2&scoped=true"
import script from "./EditOptions.vue?vue&type=script&lang=js"
export * from "./EditOptions.vue?vue&type=script&lang=js"
import style0 from "./EditOptions.vue?vue&type=style&index=0&id=8e20c8f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e20c8f2",
  null
  
)

export default component.exports